import { george, pr, theme } from "aaa";
import { ListItem } from "components/common/LandingPage";
import { NativeRaisedButton } from "components/common/NativeRaisedButton";
import { ui } from "components/util/uiHelpers";
import { observer } from "mobx-react";
import * as React from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { GooglePayRoutes } from "./GooglePayRoutes";
import { GooglePayStore } from "./GooglePayStore";
import { FormattedHTMLMessage } from "react-intl";
import { InfoBoxWithBackground } from "components/common/InfoBoxWithBackground";

type IProps = {
    store: GooglePayStore
};

export const GooglePayLandingPage = observer(({ store }: IProps) => {
    if (store.isLoading) {
        return <george.LoadingIndicator isLoading height={ui.windowHeight} />;
    }

    return (
        <george.LandingBackground useWebVersion>
            <div style={{ lineHeight: "24px" }}>
                <div style={{ padding: theme.MARGIN }}>
                    <pr.LandingPageTitle style={{ textAlign: "center" }}>
                        <FormattedHTMLMessage id="googlePay.landingPage.title" />
                    </pr.LandingPageTitle>
                </div>
                <div style={{ textAlign: "center", padding: "0px 20px" }}>
                    <img style={{ width: "100%", maxWidth: 250 }} src={require("../../assets/google_pay.svg")} />
                </div>
                <div style={{ padding: theme.MARGIN }}>
                    <pr.P_16_CONTENT>
                        <FormattedHTMLMessage id="googlePay.landingPage.text" />
                    </pr.P_16_CONTENT>
                </div>
                <pr.LightSeparatorLine spacing={theme.MARGIN} />
                <div style={{ padding: theme.MARGIN }}>
                    <InfoBoxWithBackground className="list-align-left">
                        <pr.P_16_CONTENT>
                            <FormattedHTMLMessage id="googlePay.landingPage.infoBox" />
                        </pr.P_16_CONTENT>
                    </InfoBoxWithBackground>
                </div>
                <pr.LightSeparatorLine spacing={theme.MARGIN} />
                <div style={{ padding: theme.MARGIN, textAlign: "center" }}>
                    <NativeRaisedButton
                        className="theme-action-button-background-color"
                        style={{
                            height: 60,
                            boxShadow: "none",
                            borderRadius: theme.BORDER_RADIUS,
                        }}
                        fullWidth={externalInterfaceStore.isGeorgeApp}
                        primary
                        labelStyle={{ color: "white", fontSize: 16, fontWeight: 600, textTransform: "none" }}
                        label={ui.__("googlePay.landingPage.next")}
                        onClick={() => {
                            pushRoute(GooglePayRoutes.PERSONAL_DATA);
                        }}
                    />
                </div>
            </div>
        </george.LandingBackground>
    );
});


// WEBPACK FOOTER //
// ./src/components/googlePay/GooglePayLandingPage.tsx